"use client"

import { useRef, useState } from "react"
import Link from "next/link"
import { Button } from "@/components/ui/button"
import { ArrowRight, Loader2 } from "lucide-react"

/**
 * CTA for the affiliate program landing page. Client leaf so the page itself
 * stays a server component. Locks its width on click and swaps to a spinner
 * per the house loading-state rule.
 */
export function ApplyButton({ href, size = "lg", className }) {
  const [loading, setLoading] = useState(false)
  const ref = useRef(null)

  return (
    <Button asChild size={size} className={className}>
      <Link
        ref={ref}
        href={href}
        onClick={() => {
          if (ref.current) ref.current.style.minWidth = `${ref.current.offsetWidth}px`
          setLoading(true)
        }}
        className={loading ? "pointer-events-none" : undefined}
      >
        {loading ? (
          <>
            <Loader2 className="h-4 w-4 animate-spin" />
            {"Loading..."}
          </>
        ) : (
          <>
            {"Apply now"}
            <ArrowRight className="h-4 w-4" />
          </>
        )}
      </Link>
    </Button>
  )
}
